import { jsx as _jsx } from "react/jsx-runtime";
import useInvoicePaymentModal from "hooks/invoice/useInvoicePaymentModal";
import React, { createContext, useContext } from "react";
var InvoicePaymentModalFormContext = /*#__PURE__*/ createContext(undefined);
export var InvoicePaymentModalFormProvider = function(param) {
    var children = param.children;
    var contextValue = useInvoicePaymentModal();
    return /*#__PURE__*/ _jsx(InvoicePaymentModalFormContext.Provider, {
        value: contextValue,
        children: children
    });
};
export var useInvoicePaymentModalFormContext = function() {
    var context = useContext(InvoicePaymentModalFormContext);
    if (!context) {
        throw new Error("useInvoicePaymentModalFormContext must be used within an FormikContext");
    }
    return context;
};
